import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface PDFViewerProps {
  pdf_url: string;
  onClose: () => void;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ pdf_url, onClose }) => {
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 p-4">
      <div className="relative w-full max-w-4xl h-[90vh] rounded-2xl shadow-2xl bg-surface">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 rounded-full bg-black/30 text-white hover:bg-black/50 transition-colors"
          aria-label="Close PDF viewer"
        >
          <X className="w-6 h-6" />
        </button>
        <iframe
          src={pdf_url}
          className="w-full h-full rounded-2xl"
          title="PDF Document Viewer"
          frameBorder="0"
        ></iframe>
      </div>
    </div>
  );
};

export default PDFViewer;
